const providerList = [
    "Driiveme",
    "HiFlow",
    "PopValet",
    "TransportingWheels"
];

export default providerList;
